import styled, { css } from "styled-components"
import {
  desktopTextStyles,
  mobileTextStyles,
  T,
} from "../shared/typography.styles"
import Breakpoints from "../shared/breakpoints"
import { FadeIn, FadeInBottom } from "../shared/keyframes.style"

export const CopyContainer = styled.div`
  color: var(--body-text-grey);
  display: flex;
  flex-direction: column;

  align-items: center;

  text-align: center;

  @media (min-width: ${Breakpoints.lg}) {
    align-items: flex-start;
    text-align: left;
  }
`

export const StatItem = styled.li`
  display: flex;
  align-items: center;
  padding: 20px 0 0 10vw;
  text-align: left;

  :nth-child(2) {
    align-self: center;
  }

  @media (min-width: ${Breakpoints.md}) {
    flex-direction: column;
    padding: 8px 0 0 0;
    text-align: center;
    :nth-child(2) {
      align-self: unset;
    }
  }

  @media (min-width: ${Breakpoints.lg}) {
    text-align: left;
    align-items: flex-start;
  }
`

export const StatRow = styled.ul`
  display: flex;
  padding: 8px 0 0 0;
  flex-direction: column;
  align-self: flex-start;
  width: 100%;

  @media (min-width: ${Breakpoints.md}) {
    & > ${StatItem}:not(:last-child) {
      padding-right: 16px;
    }
    align-self: center;

    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
  }

  @media (min-width: ${Breakpoints.lg}) {
    justify-content: flex-start;
    align-self: flex-start;
  }
`

export const StatItemNumber = styled.span`
  letter-spacing: 140%;
  ${mobileTextStyles.MobileHeadingTwoRegular}

  & > span {
    line-height: 0px;
  }

  padding-right: 12px;

  @media (min-width: ${Breakpoints.lg}) {
    ${desktopTextStyles.HeadingThreeRegular}

    & > span {
      font-size: 18px;
    }
  }
`

export const StatItemDescription = styled.span`
  ${desktopTextStyles.LinkText}
  line-height: 140%;
  opacity: 0.5;
  letter-spacing: 0.05em;
`
export const CopyText = styled.p`
  ${T.sm.body.regular}
  padding: 32px 0;
  & > em {
    font-weight: 500;
  }

  @media (min-width: ${Breakpoints.md}) {
    ${T.md.body.regular}
  }

  @media (min-width: ${Breakpoints.lg}) {
    ${desktopTextStyles.BodyText18}
    padding: 32px 0 64px 0;
    max-width: 82%;
  }
`

export const LinkStyle = css`
  flex-grow: 1;
`

export const OutlineLinkStyle = css`
  ${LinkStyle}
  background: none;
  border: 1px solid var(--body-text-grey);
`

export const LinkContainer = styled.div`
  max-width: 282px;
  width: 282px;
  display: flex;
  flex-wrap: wrap;
  align-self: center;

  @media (min-width: ${Breakpoints.lg}) {
    align-self: flex-start;
  }
`

export const DividingLine = styled.div`
  max-width: 480px;
  border-top: 1px solid var(--dark-mode-heading);
  margin-top: 24px;
  width: 66.6vw;
  @media (min-width: ${Breakpoints.lg}) {
    width: 33.3vw;
  }
`

export const ProjectDescriptionContainer = styled.div`
  flex: 1 1 40%;

  align-self: center;

  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 48px;

  @media (min-width: ${Breakpoints.md}) {
    margin-bottom: 48px;
  }
  @media (min-width: ${Breakpoints.lg}) {
    align-items: flex-start;
    margin-bottom: 0;
  }

  ${(props) => props.styles};

  & > *:first-child,
  ${DividingLine} {
    animation: ${(props) =>
      !props.disableAnimations && props.animated && FadeIn};
    animation-play-state: ${(props) =>
      props.isVisible ? "running" : "paused"};

    animation-duration: 1s;
    animation-timing-function: ease;
    animation-delay: 0.7s;
    animation-fill-mode: both;
  }

  ${CopyContainer} > *:first-child {
    animation: ${(props) =>
      !props.disableAnimations && props.animated && FadeInBottom};
    animation-play-state: ${(props) =>
      props.isVisible ? "running" : "paused"};

    animation-duration: 1s;
    animation-timing-function: ease;
    animation-delay: 0.9s;
    animation-fill-mode: both;
  }

  ${CopyContainer} > *:not(:first-child) {
    animation: ${(props) =>
      !props.disableAnimations && props.animated && FadeInBottom};
    animation-play-state: ${(props) =>
      props.isVisible ? "running" : "paused"};

    animation-duration: 1s;
    animation-timing-function: ease;
    animation-delay: 1.3s;
    animation-fill-mode: both;
  }
`
